import {atProp,innateHTMLMethod} from "./View";


export default {
    id:"Fragment",
    parent:"DocumentFragment",
    type:"(props:object):Fragment",
    experimental:true,
    props:[
        {
            name:"parent",
            type:"HTMLElement",
            description:"The element in which the fragment nodes will be inserted",
        },
        atProp,
    ],
    methods:[
        innateHTMLMethod,
        {
            name:"beforeEndHTML",type:"string",
            description:"Inserts safely the HTML or XML markup after the last node",
        },
        {
            name:"afterBeginHTML",type:"string",
            description:"Inserts safely the HTML or XML markup before the first node",
        },
        {
            name:"substitute",
            type:"(substitute:Node):Node",
            description:"Replaces all the fragment nodes by another node and returns the substitute",
        },
        {
            name:"adjacentTo",
            type:"(element:Element,before?:boolean):CherryFragment",
            description:"Inserts the fragment childNodes before or after an element and returns the current fragment",
            props:[
                {
                    name:"element",type:"Element",
                    description:"Element before/after which the nodes are inserted",
                },
                {
                    name:"before",type:"boolean",
                    description:"if true the nodes are inserted before the element otherwise after, default to false",
                },
            ],
        },
        {
            name:"prepend",type:"(...nodes:Node[]):void",
            description:"Inserts nodes before the first child of the fragment",
        },
        {
            name:"append",type:"(...nodes:Node[]):void",
            description:"Inserts nodes after the last child of the fragment",
        },
        {
            name:"appendChild",type:"<Type extends Node>(node:Type):Type",
            description:"Inserts a node after the last child of the fragment",
        },
        {
            name:"prependTo",type:"(newParent:HTMLElement):void",
            description:"Inserts the fragment nodes before the first child of the new parent",
        },
        {
            name:"appendTo",type:"(newParent:HTMLElement):void",
            description:"Inserts the fragment nodes after the last child of the new parent",
            notice:`
                should use <span>prependTo</span> and <span>appendTo</span> respectively instead of 
                newParent.<span>prepend</span>(fragment) and newParent.<span>append</span>(fragment)
                otherwise unexpected behavior may occur
                @This usage requirement may change in future versions
            `,
        },
        {
            name:"remove",type:"():void",
            description:"Removes All fragment nodes from DOM",
        },
        {
            name:"childNodes",type:"Node[]",
            description:"Returns the children",
        },
        {
            name:"children",type:"Element[]",
            description:"Returns the child elements",
        },
        {
            name:"parentNode",type:"ParentNode|null",
            description:"Returns the fragment's parent node",
        },
    ],
}
